import { UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";

const clientSecret = import.meta.env.VITE_AUTH_CLIENT_SECRET?.trim();

export const authConfig: UserManagerSettings = {
  authority: "https://auth.loadrpm.com",
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: "https://auth.loadrpm.com/Account/Login",
  client_id: import.meta.env.VITE_AUTH_CLIENT_ID ?? "",
  // Omit empty secret so public/PKCE clients are not sent client_secret=""
  ...(clientSecret ? { client_secret: clientSecret } : {}),
  response_type: "code",
  scope: "openid profile",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Persist OIDC state across IdP redirects (sessionStorage can be dropped in some browsers)
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
};
